module.exports = __webpack_public_path__ + "img/exit-icon.5ec794a3.png";